define('errorHandler',["jquery", 'loglevel'], function($, log) {
    "use strict";

    var logErrorUrl = "/scorebootstrapui/logerror";

    function ErrorHandler() {
        this.logError = function logError(err) {
            if (!err) {
                return;
            }

            err = String(err);
            $.post(logErrorUrl, { message: err }).fail(function () {
                log.error("Failed to log error on server: " + err);
            });
        };
    }

    return new ErrorHandler(); //singleton
});
